import React from "react";
import { usd, px } from "./floorUtil";

export const TvPositions = ({ positions, hidden, equity }) => {
  const open = (positions || []).filter((p) => p.status === "open").sort((a, b) => Number(b.notional || 0) - Number(a.notional || 0));
  return (
    <section className="fc-panel fx-glow flex-1 min-h-0 p-[0.6em] flex flex-col" data-testid="tv-positions">
      <p className="fc-label mb-[0.3em]">Open positions · {open.length}</p>
      <div className="flex-1 min-h-0 overflow-hidden">
        <table className="w-full fc-num text-[1em]">
          <thead><tr className="text-cyan-300/60 text-left"><th className="font-normal">Symbol</th><th className="font-normal">Side</th><th className="font-normal text-right">P&L</th><th className="font-normal text-right">Size</th></tr></thead>
          <tbody>
            {open.map((p) => {
              const pct = Number(p.pnl_pct || 0), short = /short|sell|no/i.test(p.side || "");
              return (
                <React.Fragment key={p.id}>
                <tr className="border-t border-white/5" data-testid={`tv-pos-${p.symbol}`}>
                  <td className="pt-[0.3em] font-bold text-cyan-50 truncate max-w-[8em] text-[1.1em]">{p.symbol}</td>
                  <td className={`pt-[0.3em] ${short ? "fc-loss" : "fc-gain"}`}>{short ? "SHORT" : "LONG"}</td>
                  <td className={`pt-[0.3em] text-right font-bold text-[1.1em] ${pct >= 0 ? "fc-gain" : "fc-loss"}`}>{pct >= 0 ? "+" : ""}{pct.toFixed(2)}%</td>
                  <td className="pt-[0.3em] text-right text-cyan-100/80">{hidden ? (equity ? `${((Number(p.notional || 0) / equity) * 100).toFixed(1)}%` : "—") : usd(p.notional, false, 0)}</td>
                </tr>
                <tr><td colSpan={4} className="pb-[0.3em] text-cyan-300/60 truncate">entry {px(p.entry)} · stop <span className="fc-loss">{px(p.stop)}</span> · target <span className="fc-gain">{px(p.target)}</span></td></tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
        {!open.length && <p className="fc-num text-[1em] text-cyan-200/50 py-[0.5em]">Book is flat.</p>}
      </div>
    </section>
  );
};

export const KalshiMini = ({ k, hidden }) => (
  <section className="fc-panel fx-glow p-[0.6em]" data-testid="tv-kalshi">
    <p className="fc-label mb-[0.2em]">Kalshi desk · today</p>
    <div className="grid grid-cols-3 gap-[0.5em] fc-num">
      <div><p className="fc-label">Open</p><p className="font-bold text-[1.5em] text-cyan-50" data-testid="tv-kalshi-open">{k?.open ?? "—"}</p></div>
      <div><p className="fc-label">W / L</p><p className="font-bold text-[1.5em] text-cyan-50">{k ? `${k.wins}/${Math.max(0, (k.closed || 0) - (k.wins || 0))}` : "—"}</p></div>
      <div><p className="fc-label">{hidden ? "Trades" : "P&L"}</p><p className={`font-bold text-[1.5em] whitespace-nowrap ${(k?.pnl || 0) >= 0 ? "fc-gain" : "fc-loss"}`}>{k == null ? "—" : hidden ? k.trades : usd(k.pnl, false, 2)}</p></div>
    </div>
  </section>
);

export const TvTicker = ({ items, hidden }) => {
  const list = (items || []).filter((x) => x.text);
  if (!list.length) return <div className="fc-panel" />;
  const row = list.map((x, i) => (
    <span key={i} className="fc-num text-[1em]">
      <b className={x.k === "news" ? "text-amber-300" : x.k === "task" ? "text-[#A78BFA]" : "text-[#00F0FF]"}>{String(x.agent || "").toUpperCase()}</b>
      <span className="text-cyan-50/90"> {hidden ? x.text.replace(/\$\s?[\d,.]+/g, "•••") : x.text}</span>
    </span>
  ));
  return (
    <div className="fc-panel fx-glow overflow-hidden flex items-center" data-testid="tv-ticker">
      <div className="fc-marquee" style={{ "--dur": `${Math.max(60, list.length * 7)}s` }}>{row}{row}</div>
    </div>
  );
};
